class QuoteSlider {
    constructor(el) {
        this.parent = $(el);
        this.slider = this.parent.find('.quote-slider__slides');
        this.header = this.parent.find('.quote-slider__header');
        this.headline = this.header.find('.quote-slider__headline');
        this.subheadline = this.header.find('.quote-slider__subheadline');
        
        this.header.append("<div class='quote-slider__timer-wrap'><span class='quote-slider__timer'</span></div>");
        this.timer = this.header.find(".quote-slider__timer");

        this.slider
            .on("beforeChange", this.clearTimer() )
            .on('afterChange', this.updateHeader.bind(this))
            .on('init', this.updateHeader.bind(this) )
            .slick({
                pauseOnHover: false,
                pauseOnFocus : false,
                infinite: false
            });

    }

    timerToggle( slick ) {

         
        if( slick.slideCount === 1 ) {
            
            if( this.headline[0].innerText.trim() === "" && this.subheadline[0].innerText.trim() === "" ) {
                $(".quote-slider__header").hide()
            } else {
                this.timer.css({width: "100%"} );
            }
        } else {
            if( this.headline[0].innerText.trim() === "" && this.subheadline[0].innerText.trim() === "" )  {
                $(".quote-slider__header").hide()
            } else {  
                
                $(".quote-slider__header").show()
                
                this.timer.css({
                    width: "0%"
                }).animate({
                    width: "100%"
                }, {
                    duration: slick.options.autoplaySpeed,
                    queue: false,
                    easing: "linear" 
                });
            } 
        }
    }
    clearTimer(e, slick) {
        this.timer.stop().css({
            width: "0%"
        });
    }

    updateHeader(e, slick) {
        const currentSlide = slick.$slides[slick.currentSlide];

        const { headline, subheadline } = $(currentSlide).data();

        this.headline.text(headline);
        this.subheadline.text(subheadline);

        this.timerToggle( slick );
        
    }
}

$(() => {
    $.fn.quoteSlider = function() {
        $(this).each((index, slider) => new QuoteSlider(slider));
    };
});
